import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { autocompleteClasses, chipClasses, LinearProgress } from '@mui/material';
import { DataGridPro, GridLogicOperator } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';
import Pagination from '../Pagination';
import DataGridToolbar from '../DataGridToolbar';
const autosizeOptions = {
    expand: true,
    includeHeaders: true,
    includeOutliers: true,
};
const DataGrid = ({ dialogComponent, loading, setSort, search, filterModel, setFilterModel, rowCountState, paginationModel, gridColumns, gridRows, valueInputSxProps, disableColumnSelector = false, disableSearch = false, columnVisibilityModel, DataGridProProps, sx, slotsProps, slots, toolbarProps, }) => {
    // filter
    const filterColumns = useCallback(({ field, columns, currentFilters }) => {
        // remove already filtered fields from list of columns
        const filteredFields = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.map((item) => item.field);
        return columns
            .filter((colDef) => colDef.filterable && (colDef.field === field || !filteredFields.includes(colDef.field)))
            .map((column) => column.field);
    }, []);
    const getColumnForNewFilter = useCallback(({ currentFilters, columns }) => {
        var _a;
        const filteredFields = currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters.map(({ field }) => field);
        const columnForNewFilter = columns
            .filter((colDef) => colDef.filterable && !filteredFields.includes(colDef.field))
            .find((colDef) => { var _a; return (_a = colDef.filterOperators) === null || _a === void 0 ? void 0 : _a.length; });
        return (_a = columnForNewFilter === null || columnForNewFilter === void 0 ? void 0 : columnForNewFilter.field) !== null && _a !== void 0 ? _a : null;
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(DataGridPro, Object.assign({ sx: Object.assign({ '& .MuiDataGrid-virtualScroller': { minHeight: '100px' } }, sx), 
                // general
                getRowId: (row) => row.Id, disableMultipleRowSelection: true, loading: loading, disableRowSelectionOnClick: true, disableColumnSelector: disableColumnSelector, columnVisibilityModel: columnVisibilityModel, slots: Object.assign({ loadingOverlay: LinearProgress, toolbar: DataGridToolbar, pagination: Pagination }, slots), slotProps: Object.assign({ pagination: {
                        current: paginationModel.current,
                        pages: paginationModel.pages,
                        pageSize: paginationModel.pageSize,
                        onPageNumberChange: paginationModel.onPageNumberChange,
                        onPageSizeChange: paginationModel.onPageSizeChange,
                        boxSx: { flex: 1 },
                    }, filterPanel: {
                        filterFormProps: {
                            filterColumns,
                            valueInputProps: {
                                sx: Object.assign({ [`& .${chipClasses.root}`]: {
                                        height: '20px',
                                    }, [`& .${autocompleteClasses.input}`]: { p: '4px 0px !important' } }, valueInputSxProps),
                                InputComponentProps: {
                                    disableCloseOnSelect: true,
                                },
                            },
                        },
                        getColumnForNewFilter,
                        logicOperators: [GridLogicOperator.And],
                    }, toolbar: Object.assign({ showSearch: !disableSearch }, toolbarProps) }, slotsProps), 
                // sorting
                disableMultipleColumnsSorting: true, sortingMode: 'server', onSortModelChange: (newSort) => setSort(newSort.length > 0 ? { field: newSort[0].field, sortOrder: newSort[0].sort } : {}), 
                // filter
                filterMode: 'server', onFilterModelChange: (newFilterModel) => {
                    setFilterModel(newFilterModel);
                }, filterModel: {
                    items: filterModel,
                    quickFilterValues: [search],
                }, 
                // pagination
                pagination: true, paginationMode: 'server', rowCount: rowCountState, 
                // dimensions
                autosizeOnMount: true, autosizeOptions: autosizeOptions, 
                // data grid columns and rows
                columns: gridColumns, rows: gridRows }, DataGridProProps)), dialogComponent] }));
};
export default DataGrid;
